var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAngular(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1063_603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0151367 6.69445L18.5163 0.102539L37.5157 6.57724L34.4394 31.0552L18.5163 39.8737L2.84234 31.1724L0.0151367 6.69445Z",
    fill: "#E23237"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5155 6.57724L18.5161 0.102539V39.8737L34.4392 31.0699L37.5155 6.57724Z",
    fill: "#B52E31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5455 4.74609L7.01709 30.3959L11.3237 30.3227L13.6383 24.5364H23.9802L26.5144 30.3959L30.6306 30.4692L18.5455 4.74609ZM18.5749 12.964L22.4714 21.1086H15.1469L18.5749 12.964Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1063_603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.648,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngular);
export default __webpack_public_path__ + "static/media/angular.9795bde458e244e95ae77ae23049107f.svg";
export { ForwardRef as ReactComponent };